// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productCarouselProductStyles } from "@west/Overrides/Components/ProductCarouselProduct";
import { css } from "styled-components";

productCarouselProductStyles.productBrandWrapper = {
    css: css`
        display: inline-flex;
    `,
};

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        mergeCss: true,
        css: css`
            min-height: 32px;
            margin-bottom: 8px;
            align-items: baseline;
        `,
    },
};

productCarouselProductStyles.priceAndQtyContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        margin-top: 4px;
    `,
};

productCarouselProductStyles.productFields = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: end;
        height: 33px;
    `,
};

productCarouselProductStyles.messagesContainer = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &:empty {
            display: none;
        }
    `,
};

productCarouselProductStyles.overlayWrapper = {
    css: css`
        top: 8px;
        left: 0;
        position: absolute;
        display: inline-flex;
        & > div {
            display: flex;
        }
    `,
};

productCarouselProductStyles.badgeText = {
    weight: "bold",
    size: 10,
    lineHeight: "16px",
    transform: "uppercase",
    css: css`
        width: 100%;
        ${wrapInContainerStyles}
    `,
};

productCarouselProductStyles.productPriceWrapper = {};

productCarouselProductStyles.productPartNumbersStyles = {};

productCarouselProductStyles.productAddToListLinkStyles = {};

productCarouselProductStyles.productPriceContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        width: 100%;
    `,
};
